import { api } from "@/lib/api";

// جلب موحد لقائمة المنتجعات: وعد واحد مشترك لكل جلسة — مهما تعددت الصفحات والمكوّنات
// المستهلكة يُرسل طلب شبكة واحد فقط، ويُلغي التكرار بين المفضلة واللافتة وصفحة المالديف.
let resortsPromise = null;

export const fetchResorts = () => {
  if (!resortsPromise) {
    resortsPromise = api.get("/resorts").then(({ data }) => data || []).catch(() => []);
  }
  return resortsPromise;
};
